import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcArrowUp24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12.003 20.003c.562 0 1-.438 1-1v-11.594l4.28 4.281a.998.998 0 0 0 .72.313c.437 0 1-.375 1-1.032a.97.97 0 0 0 -.282-.687l-6-6a.975.975 0 0 0 -.61-.276l-.108-.005c-.25-.032-.515.077-.72.28l-6 6a1.026 1.026 0 0 0 -.28.688c0 .563.468 1.032 1 1.032a.981.981 0 0 0 .718-.313l4.282-4.281v11.594c0 .562.437 1 1 1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcArrowUp24;
